import Model from '@/lib/data/Model';
import Translation from './Translation';

class FormQuestionControlData extends Model {
    static idProperty = 'id';

    fields = [
        'id',
        'form_ques_id',
        'cd_key',
        'cd_value',
        'cd_order',
        { name: 'risk_score', type: 'float', defaultValue: 0 },
        { name: 'protection_score', type: 'float', defaultValue: 0 },
        { name: 'default_visibility', type: 'bool', defaultValue: true },
        'rules',
        {
            name: 'translation',
            association: {
                type: 'one',
                model: Translation,
            },
        },
        'ai_control_data_id',
        'is_other_value',
    ];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'save',
            url: '/forms/form/question/addoption',
            params: ['form_ques_id', 'option'],
        },
    ];
}

export default FormQuestionControlData;
